<script>
export default {
  name: 'PageFooter'
}
</script>

<template>
  <footer id="footer">
    <div class="container footer-bottom clearfix">
      <div class="copyright">
        {{ $t('footer.copyright', {year: new Date().getFullYear()}) }}
      </div>

    </div>
  </footer>
  <a href="#"
     class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>
  <!--  <div id="preloader"></div>-->

</template>

<style scoped>

</style>